


































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Api from "@/api";
import { AxiosResponse } from "axios";
import Table from "@/components/Common/Table.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import { EventTimeframe, IEvent, IPagination, ITableParams } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    AlertBox
  }
})
export default class Events extends Vue {
  public loading = false;
  public updating = false;
  private componentKey = 0;
  private events: Array<IEvent> = [];
  private eventTypes: Array<string> = [];
  private eventTimeframes: Array<EventTimeframe> = [];
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    to: 1,
    search: ""
  };
  private timeframeFilter = "current";
  private typeFilter = "course";
  private selectedEventId: string | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedEventId = vm.$route.params.event_id;
      vm.getEvents(() => {
        //
      });
      vm.getEventTypes();
      vm.getEventTimeframes();
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getEvents(() => {
      //
    });
    this.getEventTypes();
    this.getEventTimeframes();
    next();
  }

  private getEvents(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.events = [];
    const endpoint = this.$partnerEndpoint("events");

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search,
          timeframe: this.timeframeFilter,
          type: this.typeFilter
        }
      })
      .then((response: AxiosResponse) => {
        this.events = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getEventTypes(): void {
    const endpoint = this.$partnerEndpoint("events/types");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.eventTypes = response.data.data;
      });
  }

  private getEventTimeframes(): void {
    const endpoint = this.$partnerEndpoint("events/timeframes");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.eventTimeframes = response.data.data;
      });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  @Watch("typeFilter")
  typeFilterChanged(): void {
    this.getEvents(() => {
      //
    });
  }

  @Watch("timeframeFilter")
  timeframeFilterChanged(): void {
    this.getEvents(() => {
      //
    });
  }
}
